
import { HStack, Box, Skeleton, SkeletonCircle, SkeletonText, List, Flex } from '@chakra-ui/react';
import { Separator } from '@components';

const FetchItems = () => {
    return (
    <HStack 
        position="relative"
        boxShadow="2px 2px 20px 0px #00000026"
        borderRadius="4px"
        h="125px" w="380px" maxW="100%" 
        p=".5rem 1rem" m="14px">

        <SkeletonCircle w="90px" h="90px" my="auto" />

        <List fontSize="12px" w="calc(100% - 100px)">
            <SkeletonText noOfLines={4} w="140px"/>
        </List>

        <Box pos="absolute" right="16px" top="8px">
            <SkeletonCircle size="6" />
        </Box>
    </HStack>
)};

const PersonDetails = () => {
    return (
        <Box w="100%" fontSize="14px">
            <Box display="flex" justifyContent="space-between" flexDir="row" flexWrap="wrap" pos="relative">
                <Box display="inline-block">
                    <SkeletonCircle size="80px" display="inline-block" verticalAlign="middle"/>
                    <Box display="inline-block" ml="1rem" verticalAlign="middle" maxW="calc(100% - 96px)">
                        <SkeletonText noOfLines={2} w="100px"/>
                    </Box>
                </Box>
                <HStack
                    w={["","","200px"]} 
                    h={["115px","","auto"]} 
                    pos={["absolute","","initial"]} 
                    top="0" right="0" 
                    justifyContent="space-between" 
                    alignItems={["flex-end","","center"]}
                    flexDir={["column-reverse", "", "row"]}>
                    <Skeleton border="solid 2px" borderRadius="99px" w="150px" h="40px" />
                    <SkeletonCircle size="28px"/>
                </HStack>
            </Box>

            <SkeletonText noOfLines={1} w="100px" mt={["80px","","28px"]} mb="15px" />
            <SkeletonText noOfLines={8} w="300px"/>
            <Separator ml="1.5rem !important" my="16px !important" />
            <SkeletonText noOfLines={4} w="80%" />
        </Box>
    )
};

const Profile = () => {
    return(
        <HStack>
            
        </HStack>
    )
};

const AnnonceItems = () => {
    return(
        <HStack 
            position="relative"
            boxShadow="2px 2px 20px 0px #00000026"
            borderRadius="4px"
            h="125px" w="380px" maxW="100%" 
            p=".5rem 1rem" m="14px">

            <List fontSize="12px" w="calc(100% - 100px)">
                <SkeletonText noOfLines={4} w="140px"/>
            </List>

            <Flex flexDir="column" justifyContent="center" h="100%" w="95px" alignItems="flex-end" m="0">
                <Skeleton h="30px" mb="1rem" borderRadius="4px">
                  <div>contents wrapped</div>
                  <div>won't be visible</div>
                </Skeleton>
                <Skeleton h="30px" mb="1rem" borderRadius="4px">
                  <div>contents wrapped</div>
                  <div>won't be visible</div>
                </Skeleton>
            </Flex>
        </HStack>
    )
}

const CustomSkeleton = ({ type }) => {
    return(
        type === "FETCH_ITEMS" ? <FetchItems /> :
        type === "PROFIL" ? <Profile /> : 
        type === "PERSON_DETAILS" ? <PersonDetails /> : 
        type === "ANNONCE_ITEMS" ? <AnnonceItems />
        : "wrong type !"
    )
}

export default CustomSkeleton;